<template>
  <div class="exams-orders-data-table">
    <table class="exams-orders-data-table-table">
      <colgroup>
        <col class="exams-orders-data-table-cell-os">

        <col class="exams-orders-data-table-cell-patient">

        <col class="exams-orders-data-table-cell-exams">

        <col class="exams-orders-data-table-cell-arrow">
      </colgroup>

      <thead class="exams-orders-data-table-header">
        <tr class="exams-orders-data-table-header-row">
          <th
            class="exams-orders-data-table-header-cell"
          >
            OS Alvaro/Lis
          </th>

          <th
            class="exams-orders-data-table-header-cell"
          >
            Paciente
          </th>

          <th
            class="exams-orders-data-table-header-cell"
          >
            Exame
          </th>

          <th />
        </tr>
      </thead>

      <tbody class="exams-orders-data-table-body">
        <template v-for="order in orders">
          <tr
            class="exams-orders-data-table-body-row"
            :class="{
              'exams-orders-data-table-open-row': openRows.includes(order.id)
            }"
            @click="handleToggleRowDetails(order)"
          >
            <td
              class="exams-orders-data-table-body-cell exams-orders-data-table-body-cell-os"
            >
              {{ getOSAOLorLIS(order) }}
            </td>

            <td
              class="exams-orders-data-table-body-cell exams-orders-data-table-body-cell-patient"
            >
              {{ order.patientName }}
            </td>

            <td
              class="exams-orders-data-table-body-cell exams-orders-data-table-body-cell-exams"
            >
              <div class="exams-orders-data-table-body-cell-exams-label">
                {{ getExamsCounterText(order) }}
              </div>

              <div class="exams-orders-data-table-body-cell-exams-value">
                {{ order.destination }}
              </div>
            </td>

            <td
              class="exams-orders-data-table-body-cell exams-orders-data-table-body-cell-arrow"
            >
              <svg-loader
                src="/static/images/icon-caret.svg"
                class="exams-orders-data-table-caret"
              />
            </td>
          </tr>

          <tr
            v-if="openRows.includes(order.id)"
            class="exams-orders-data-table-body-details-row"
          >
            <td
              class="exams-orders-data-table-body-details-cell"
              :colspan="4"
            >
              <exams-data-table :os="order" />
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import ExamsDataTable from './ExamsDataTable'

export default {
  name: 'ExamsOrdersDataTable',
  components: {
    ExamsDataTable
  },
  props: {
    exams: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      openRows: []
    }
  },
  computed: {
    orders() {
      const groupedByOrderId = Object.groupBy(this.exams, ({ idOrder }) => idOrder)

      return Object.keys(groupedByOrderId).map(key => {
        const exams = groupedByOrderId[key]
        const [firstExam] = exams

        return {
          id: key,
          patientName: firstExam.patientName,
          destination: firstExam.destination,
          idOrder: firstExam.idOrder,
          isOrderLis: firstExam.IdOsLis,
          exams,
        }
      })
    },
  },
  methods: {
    getExamsCounterText(order) {
      const counter = order.exams.length

      return counter > 1 ? `${counter} exames` : `${counter} exame`
    },
    getOSAOLorLIS({ idOrder, isOrderLis }) {
      let value = `${idOrder}`

      if (isOrderLis) {
        value += `/${isOrderLis}`
      }

      return value
    },
    handleToggleRowDetails(order) {
      if (this.openRows.includes(order.id)) {
        this.openRows = this.openRows.filter(id => id !== order.id)
      } else {
        this.openRows = [...this.openRows, order.id]
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.exams-orders-data-table {
  width: 100%;
  font-family: 'Exo 2';

  &-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }

  &-header {
    &-row {
      border-bottom: 2px solid #7A7A7A;
    }

    &-cell {
      text-align: left;
      font-weight: 600;
      font-size: 0.75rem;
      text-transform: uppercase;
      color: #7A7A7A;
      padding: 1.5rem 1rem;
    }
  }

  &-body {
    &-row {
      cursor: pointer;

      &:hover {
        background-color: #F9F9F9;
      }
    }

    &-cell {
      padding: 1.5rem 1rem;

      &-os {
        font-weight: 400;
        font-size: 0.875rem;
      }

      &-patient {
        font-weight: 700;
        font-size: 1rem;
        color: #F78E26;
      }

      &-exams {
        font-size: 0.875rem;

        &-label {
          font-weight: 700;
          color: #7F1A54;
        }

        &-value {
          font-weight: 400;
          color: #363636;
        }
      }
    }

    &-details {
      &-cell {
        background-color: #F3F3F3;
      }
    }
  }

  &-cell {
    &-arrow {
      width: 60px;
    }
  }

  &-caret {
    width: 0.5rem;
    min-width: auto;
    transform: rotate(180deg);
    transition: transform 0.2s ease;
  }

  &-open-row &-caret {
    transform: rotate(0deg);
  }

  .btn-icon-rounded {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;

    .md-icon {
      width: 1rem;
      height: 1rem;
      min-width: auto;
      min-height: auto;
    }
  }
}
</style>
